import { NextPage } from 'next'

import InvoiceLayout from '@/layouts/InvoiceLayout'

const InvoiceLanding: NextPage = () => <InvoiceLayout />

export default InvoiceLanding
